import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authFetch } from "../utils/authFetch";

const euro = (valore) =>
  Number(valore || 0).toLocaleString("it-IT", {
    style: "currency",
    currency: "EUR",
  });

const stati = {
  DRAFT: "Bozza",
  SUBMITTED: "Inviato",
  APPROVED: "Approvato",
  FULFILLED: "Evaso",
  CANCELED: "Annullato",
  INVIATO: "Inviato",
};

export default function AppAziendaOrdiniPage() {
  const navigate = useNavigate();
  const [ordini, setOrdini] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errore, setErrore] = useState("");

  useEffect(() => {
    let attivo = true;

    async function carica() {
      try {
        const response = await authFetch("/api/ordini/miei/");
        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            typeof data.detail === "string"
              ? data.detail
              : "Impossibile caricare gli ordini."
          );
        }

        const elenco = Array.isArray(data)
          ? data
          : Array.isArray(data.results)
            ? data.results
            : Array.isArray(data.ordini)
              ? data.ordini
              : [];

        if (attivo) {
          setOrdini(
            [...elenco].sort((a, b) => Number(b.id) - Number(a.id))
          );
        }
      } catch (error) {
        if (attivo) setErrore(error.message);
      } finally {
        if (attivo) setLoading(false);
      }
    }

    carica();
    return () => { attivo = false; };
  }, []);

  return (
    <div className="container py-4" style={{ maxWidth: 850 }}>
      <button
        type="button"
        className="btn btn-link px-0"
        onClick={() => navigate("/app")}
      >
        ← Area Azienda
      </button>

      <div className="d-flex justify-content-between align-items-center gap-3 mb-4">
        <h2 className="fw-bold mb-0">I miei ordini</h2>
        <button
          type="button"
          className="btn btn-dark rounded-pill"
          onClick={() => navigate("/app/azienda/ordini/nuovo")}
        >
          Nuovo ordine
        </button>
      </div>

      {loading && <p>Caricamento ordini...</p>}

      {errore && (
        <div className="alert alert-danger" role="alert">
          {errore}
        </div>
      )}

      {!loading && !errore && ordini.length === 0 && (
        <div className="card">
          <div className="card-body text-center py-5">
            <h5>Nessun ordine presente</h5>
            <p className="text-muted">
              Puoi creare il tuo primo ordine dal catalogo aziendale.
            </p>
          </div>
        </div>
      )}

      <div className="d-flex flex-column gap-3">
        {ordini.map((ordine) => (
          <div className="card" key={ordine.id}>
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-start gap-3">
                <div>
                  <h5 className="fw-bold mb-1">
                    Ordine #{ordine.id}
                  </h5>
                  <div className="text-muted">
                    Stato: {ordine.status_it || stati[ordine.status] || ordine.status}
                  </div>
                </div>
                <strong>{euro(ordine.total)}</strong>
              </div>

              <button
                type="button"
                className="btn btn-outline-dark rounded-pill w-100 mt-3"
                onClick={() =>
                  navigate(`/app/azienda/ordini/${ordine.id}/riepilogo`)
                }
              >
                {ordine.status === "DRAFT"
                  ? "Riprendi bozza"
                  : "Visualizza ordine"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
